import { render } from "./Step2PatientInformation.vue?vue&type=template&id=59f6608c"
import script from "./Step2PatientInformation.vue?vue&type=script&lang=js"
export * from "./Step2PatientInformation.vue?vue&type=script&lang=js"

import "./Step2PatientInformation.vue?vue&type=style&index=0&id=59f6608c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__